<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3490_10377)">
      <path
        d="M2.625 13.5C2.32663 13.5 2.04048 13.3815 1.8295 13.1705C1.61853 12.9595 1.5 12.6734 1.5 12.375V2.625C1.5 2.32663 1.61853 2.04048 1.8295 1.8295C2.04048 1.61853 2.32663 1.5 2.625 1.5H9.735C9.97015 1.50003 10.1968 1.58784 10.3706 1.74625L13.1919 4.31687C13.2889 4.40531 13.3665 4.51302 13.4195 4.63312C13.4726 4.75322 13.5 4.88307 13.5 5.01437V12.375C13.5 12.5227 13.4709 12.669 13.4144 12.8055C13.3578 12.942 13.275 13.066 13.1705 13.1705C13.066 13.275 12.942 13.3578 12.8055 13.4144C12.669 13.4709 12.5227 13.5 12.375 13.5H2.625ZM12.375 12.375V5.095L9.665 2.62563H9.5625V3.9375C9.5625 4.38505 9.38471 4.81428 9.06824 5.13074C8.75177 5.44721 8.32255 5.625 7.875 5.625H5.0625C4.61495 5.625 4.18572 5.44721 3.86926 5.13074C3.55279 4.81428 3.375 4.38505 3.375 3.9375V2.625H2.625V12.375H3.5625V10.125C3.5625 9.67745 3.74029 9.24823 4.05676 8.93176C4.37322 8.61529 4.80245 8.4375 5.25 8.4375H9.75C10.1976 8.4375 10.6268 8.61529 10.9432 8.93176C11.2597 9.24823 11.4375 9.67745 11.4375 10.125V12.375H12.375ZM10.3125 12.375V10.125C10.3125 10.0511 10.298 9.97799 10.2697 9.90974C10.2414 9.8415 10.2 9.77949 10.1477 9.72725C10.0955 9.67502 10.0335 9.63359 9.96526 9.60532C9.89701 9.57705 9.82387 9.5625 9.75 9.5625H5.25C5.10082 9.5625 4.95774 9.62176 4.85225 9.72725C4.74676 9.83274 4.6875 9.97582 4.6875 10.125V12.375H10.3125ZM4.5 3.9375C4.5 4.08668 4.55926 4.22976 4.66475 4.33525C4.77024 4.44074 4.91332 4.5 5.0625 4.5H7.875C8.02418 4.5 8.16726 4.44074 8.27275 4.33525C8.37824 4.22976 8.4375 4.08668 8.4375 3.9375V2.625H4.5V3.9375Z"
        fill="#AFAFBE"
      />
    </g>
    <defs>
      <clipPath id="clip0_3490_10377">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
svg path {
  fill: currentColor;
}
</style>
